export default {
    mounted(el, binding) {
        window.addEventListener('click', ev => {
            if (ev.target instanceof HTMLElement && el.contains(ev.target)) {
                ev.stopPropagation();
                return;
            }
            if (typeof binding.value === 'function') {
                binding.value();
            }
        });
    },
};
